import { createQueryData } from '../helpers/createQueryData';

const { useQuery: useAddressStepsQuery } = createQueryData({
  endPoint: 'Acceptance/step_address_life_cycle',
  options: {
    errorMessage: 'Не удалось получить список возможных этапов помещений',
  },
});

export { useAddressStepsQuery };
